//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CardPropertyIcon from '../../components/Card/CardPropertyIcon.vue'
import { cardPropertyMixin } from '../../components/Card/CardPropertyMixin.js'
import { getEmployeePasswordRequirements } from './EmployeePasswordRequirements.js'
import UserPassword from '../../pages/main/sections/UserSettings/UserPassword.vue'

export default {
  name: 'EmployeePropertyPassword',
  components: {
    CardPropertyIcon,
    UserPassword
  },
  mixins: [cardPropertyMixin],
  props: {
    tabProp: {
      type: Object,
      required: true
    },
    object: {
      type: Object,
      default: null
    },
    objectInitial: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      rule: null

    }
  },
  computed: {
    value: {
      get: function () {
        return this.object[this.tabProp.key]
      },
      set: function (value) {
        this.object[this.tabProp.key] = value
      }
    },
    valueInitial: function () {
      return this.objectInitial[this.tabProp.key]
    },
    componentProps: function () {
      return (this.tabProp && this.tabProp.componentProps) || {}
    }
  },
  created: async function () {
    this.rule = await getEmployeePasswordRequirements(this.object.user[0], {
      minLength: this.tabProp.minLength,
      minDigitsCount: this.tabProp.minDigitsCount,
      minLettersCount: this.tabProp.minLettersCount,
      lowerAndUpperCasesRequired: this.tabProp.lowerAndUpperCasesRequired
    })
  }
}
